module.exports = __webpack_public_path__ + "static/media/summary2.6c50657a.svg";